import { Reveal } from "./primitives";
import { ABOUT_ARC } from "@/data/content";
import { ArrowRight } from "lucide-react";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#e24a29]">About</span>
      </Reveal>

      <div className="mt-8 grid lg:grid-cols-[1fr_1.1fr] gap-12 lg:gap-20">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02]">
            I don&apos;t pick one lane. I follow the outcome.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="space-y-6 text-lg text-[#57534e] leading-relaxed max-w-xl">
          <p>
            My path wasn&apos;t a straight line — and that&apos;s the point. I started as an{" "}
            <span className="text-[#1c1b1a] font-semibold">engineer</span>, learning how systems really work. I moved
            into <span className="text-[#1c1b1a] font-semibold">product design</span>, learning craft, clarity and how
            to think about the person on the other side.
          </p>
          <p>
            Today I&apos;m a <span className="text-[#1c1b1a] font-semibold">marketer</span> who moves fluidly between
            organic social, paid media and automation/GTM tooling. Give me a content problem, a paid-ads problem or a
            growth-systems problem — I&apos;ll figure out which one it actually is first.
          </p>
        </Reveal>
      </div>

      {/* career arc */}
      <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-px bg-[rgba(28,27,26,0.12)] rounded-2xl overflow-hidden border border-[rgba(28,27,26,0.12)]">
        {ABOUT_ARC.map((a, i) => (
          <Reveal key={a.step} delay={i * 0.12} className="bg-[#f5f3ef]">
            <div className="p-8 h-full relative group hover:bg-[#fffdf9] transition-colors duration-300">
              <div className="flex items-center gap-3 mb-6">
                <span className="font-display text-2xl font-bold text-[#e24a29]">{a.step}</span>
                {i < ABOUT_ARC.length - 1 && (
                  <ArrowRight size={18} className="text-[#57534e] hidden md:block" />
                )}
              </div>
              <h3 className="font-display text-2xl font-bold mb-3">{a.label}</h3>
              <p className="text-[#57534e] leading-relaxed">{a.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
